import { createRouter, createWebHistory } from 'vue-router'
const defaultTitle = 'testdrive'
const environment = window.config.environment
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: { layout: 'side-nav' },
      component: () => import('../pages/index.vue')
    },
    {
      path: '/login',
      name: 'Login',
      meta: { allowAnonymous: true },
      component: () => import('../pages/login/index.vue')
    },
    {
      path: '/onboard/:id',
      meta: { allowAnonymous: true },
      children: [
        {
          path: '',
          name: 'Onboard',
          meta: { layout: 'no-nav' },
          component: () => import('../pages/onboard/index.vue')
          }
      ]
    },
    {
      path: '/contacts',
      children: [
        {
          path: '',
          name: 'Contacts',
          meta: { layout: 'default' },
          component: () => import('../pages/contacts/index.vue')
        }
      ]
    },
    {
      path: '/fleet',
      children: [
        {
          path: '',
          name: 'Fleet',
          meta: { layout: 'default' },
          component: () => import('../pages/fleet/index.vue')
        }
      ]
    },
    {
      path: '/insurance',
      children: [
        {
          path: '',
          name: 'Insurance',
          meta: { layout: 'default' },
          component:() => import('../pages/insurance/index.vue')
        }
      ]
    },
    {
      path: '/dashboard',
      children: [
        {
          path: '',
          name: 'Dashboard',
          meta: { layout: 'default' },
          component:() => import('../pages/dashboard/index.vue')
        }
      ]
    },
    {
      path: '/locations',
      children: [
        {
          path: '',
          name: 'Locations',
          meta: { layout: 'default' },
          component:() => import('../pages/locations/index.vue')
        }
      ]
    },
    {
      path: '/testdrives',
      children: [
        {
          path: '',
          name: 'Test Drives',
          meta: { layout: 'default' },
          component:() => import('../pages/testdrives/index.vue')
        }
      ]
    },
    {
      path: '/admin',
      name: 'Administration',
      meta: { layout: 'side-nav' },
      component:() => import('../pages/admin/index.vue')
    },
    {
      path: '/configuration',
      children: [
        {
          path: '',
          name: 'Configuration Settings',
          meta: { layout: 'side-nav' },
          component:() => import('../pages/admin/configuration/index.vue')
          
        }
      ]
    },
    {
      path: '/data',
      children: [
        {
          path: '',
          name: 'Import/Export Facility',
          meta: { layout: 'side-nav' },
          component:() => import('../pages/admin/import-data/index.vue')
        }
      ]
    },
    {
      path: '/users',
      children: [
        {
          path: '',
          name: 'Users',
          meta: { layout: 'default' },
          component:() => import('../pages/users/index.vue')
        }
      ]
    },
    {
      path: '/storage',
      children: [
        {
          path: '',
          name: 'Storage',
          meta: { layout: 'default' },
          component:() => import('../pages/storage/index.vue')
        }
      ]
    },
    {
      path: '/video',
      children: [
        {
          path: '',
          name: 'video',
          meta: { allowAnonymous: true },
          component:() => import('../pages/video/index.vue')
        }
      ]
    },
    // {
    //   path: '*',
    //   name: 'Page not Found',
    //   component:() => import('../pages/errors/error-404.vue')
    // }
  ],
})
router.beforeEach((to, from, next) => {
  let env = environment === 'prod' ? '' : `[${environment}]`

  if (to.name) {
    document.title = `${to.name} -  ${defaultTitle} ${env}`.trim()
  } else {
    document.title = `${defaultTitle} -  ${defaultTitle} ${env}`
  }

  next()
})
export default router
